import invariant from 'invariant';
export const getTierCeiling = tier => {
  const tierCeiling = tier.ceiling;
  invariant(typeof tierCeiling === 'number', 'Ceiling cannot be unspecified for cloud');
  return tierCeiling;
};
export const CURRENCY_TO_LOCALE = {
  JPY: 'ja-JP',
  USD: 'en-US'
};
export const formatAmount = (amount, options) => {
  const {
    currency,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2
  } = options;
  const locale = CURRENCY_TO_LOCALE[currency] || CURRENCY_TO_LOCALE.USD;
  return amount.toLocaleString(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits,
    maximumFractionDigits
  });
};